import { styled } from 'styled-components';
import { useParams } from 'react-router-dom';
import { nearbyData } from 'src/assets/database/nearbyData';

import nearby1 from 'src/assets/images/user-mobile/map/nearby/popup/nearby-img-1.png';
import nearby2 from 'src/assets/images/user-mobile/map/nearby/popup/nearby-img-2.png';
import nearby3 from 'src/assets/images/user-mobile/map/nearby/popup/nearby-img-3.png';
import nearby4 from 'src/assets/images/user-mobile/map/nearby/popup/nearby-img-4.png';
import nearby5 from 'src/assets/images/user-mobile/map/nearby/popup/nearby-img-5.png';
import nearby6 from 'src/assets/images/user-mobile/map/nearby/popup/nearby-img-6.png';

import detail1 from 'src/assets/images/user-mobile/map/nearby/detail/detail-1.png';
import detail2 from 'src/assets/images/user-mobile/map/nearby/detail/detail-2.png';
import detail3 from 'src/assets/images/user-mobile/map/nearby/detail/detail-3.png';
import detail4 from 'src/assets/images/user-mobile/map/nearby/detail/detail-4.png';
import detail5 from 'src/assets/images/user-mobile/map/nearby/detail/detail-5.png';
import detail6 from 'src/assets/images/user-mobile/map/nearby/detail/detail-6.png';

import title1 from 'src/assets/images/user-mobile/map/nearby/title/title1.png';
import title2 from 'src/assets/images/user-mobile/map/nearby/title/title2.png';
import title3 from 'src/assets/images/user-mobile/map/nearby/title/title3.png';
import title4 from 'src/assets/images/user-mobile/map/nearby/title/title4.png';
import title5 from 'src/assets/images/user-mobile/map/nearby/title/title5.png';
import title6 from 'src/assets/images/user-mobile/map/nearby/title/title6.png';

const imageMap: Record<number, string> = {
  1: nearby1,
  2: nearby2,
  3: nearby3,
  4: nearby4,
  5: nearby5,
  6: nearby6,
};

const detailImageMap: Record<number, string> = {
  1: detail1,
  2: detail2,
  3: detail3,
  4: detail4,
  5: detail5,
  6: detail6,
};

const titleImageMap: Record<number, string> = {
  1: title1,
  2: title2,
  3: title3,
  4: title4,
  5: title5,
  6: title6,
};

export default function NearbyDetail() {
  const { id } = useParams();
  const data = nearbyData.find(item => item.id === Number(id));

  if (!data) return <DetailWrapper>데이터가 없습니다.</DetailWrapper>;

  const imageSrc = imageMap[data.id];
  const detailImageSrc = detailImageMap[data.id];
  const titleImageSrc = titleImageMap[data.id];

  return (
    <>
      <DetailWrapper>
        <TitleWrapper>
          {titleImageSrc && <TitleImage src={titleImageSrc} alt={data.title} />}
        </TitleWrapper>
        {imageSrc && <Image src={imageSrc} alt={data.title} />}
        <IntroductionLink
          as="a"
          href={data.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          {data.title} 소개 페이지 보기
        </IntroductionLink>{' '}
        {detailImageSrc && (
          <DetailImage src={detailImageSrc} alt={`${data.title} 상세 이미지`} />
        )}
      </DetailWrapper>

      <DetailFooter>
        <FooterTitle>
          2025 당진 삽교호 드론 라이트 쇼 웹사이트<p>페스티맵 제작</p>
        </FooterTitle>
      </DetailFooter>
    </>
  );
}

const DetailWrapper = styled.div`
  background: #fff;
  color: #111;
  background: linear-gradient(180deg, #fff 50%, #ebf4f9 100%);
`;

const TitleWrapper = styled.div`
  padding: 12px 16px 0 16px;
`;

const TitleImage = styled.img`
  width: 100%;
  height: 24px;
  object-fit: contain;
`;

const IntroductionLink = styled.a`
  display: inline-flex;
  padding: 12px 20px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 16px;
  background: #e9f2ff;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.08);
  color: #2a6fd2;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.4px;
  text-decoration: none;

  /* 중앙 정렬용 추가 */
  display: block;
  width: fit-content;
  margin: 32px auto 60px auto;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 24px;
  margin: 16px 0;
  padding: 0 16px;
`;

const DetailImage = styled.img`
  width: 100%;
  height: auto;
  padding: 0 16px;
  margin-bottom: 140px;
`;

const DetailFooter = styled.div`
  background: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

const FooterTitle = styled.div`
  color: #101010;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.4px;
  margin: 16px 0 20px;

  p {
    color: #505050;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.325px;
  }
`;
